import request from '@/utils/request'

const url = '/home/flashsale/'
const api = {
  getBuyToday (data) {
    return request({
      url: url + 'getBuyToday',
      method: 'post',
      data
    })
  },
  getFlashSale (data) {
    return request({
      url: url + 'getFlashSale',
      method: 'post',
      data
    })
  },
  getEndTime (data) {
    return request({
      url: url + 'getEndTime',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/flashsale.js